export default __webpack_public_path__ + "static/media/detail.7e4a2836.png";